import { render } from "./GlobalBurger.vue?vue&type=template&id=52b99d9c"
import script from "./GlobalBurger.vue?vue&type=script&lang=js"
export * from "./GlobalBurger.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__